import React, { useState } from 'react';
import '../../../assets/css/StudentShortDetails.css';
import edit from '../../../assets/icons/editnew.svg';

export const TransactionsShortDetails = ({ selectedFeeDetails }) => {

  const [visibleCount, setVisibleCount] = useState(15);
  const [viewMode, setViewMode] = useState("ledger");

  // Normalize to always work with an array
  const feeDetailsArray = Array.isArray(selectedFeeDetails)
    ? selectedFeeDetails
    : selectedFeeDetails
      ? [selectedFeeDetails]
      : [];

  return (
    <>
      <div className="col-md-12">
        <div className="col-md-12">
          <div
            style={{
              background: "#7f56da",
              color: "#ffffff",
              padding: "12px 16px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "8px",
              fontWeight: 600,
              fontSize: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {/* Optional Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                <path d="M10 9H8" />
                <path d="M16 13H8" />
                <path d="M16 17H8" />
              </svg>

              <span>RECEIVING&apos;S DETAILS</span>
            </div>
          </div>
        </div>

      </div>

      {feeDetailsArray.map((details, idx) => (
        <div
          key={idx}
          className="p-3 mt-4 transactionShortdetails"

          style={{
            border: "1px solid #f0f0f0",
            borderRadius: "8px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          }} >



          <div className='row'>
            <div className='col-md-6'>


              <div>
                <p className="sd-p">Student Name</p>
                <p className="alg-l">{details.student_name}</p>
              </div>
            </div>
            <div className='col-md-6'>

              <div>
                <p className="sd-p">Reg Number</p>
                <p className="alg-l">{details.permanent_registration_number}</p>
              </div>
            </div>
          </div>


          <div className='row'>
            <div className='col-md-6'>
              <div>
                <p className="sd-p">Mode Of Payment</p>
                <p className="alg-l">{details.payment_method}</p>
              </div>
            </div>
            <div className='col-md-6'>
              <div>
                <p className="sd-p">Amount</p>
                <p className="alg-l">{details?.amount?.toFixed(2)}</p>
              </div>
            </div>
            <div className='col-md-6'>
              <div>
                <p className="sd-p">Status</p>
                <p className="alg-l">{details.payment_status}</p>
              </div>
            </div>

            <div className='col-md-6'>
              <div>
                <p className="sd-p">Received By</p>
                <p className="alg-l">{details.transfered_to}</p>
              </div>
            </div>
          </div>





          {/* Show cheque/DD/UTR details if mode is not Cash */}
          {details.payment_method !== "Cash" && (
            <div>
              {details.cheque_details && (
                <>


                  <div className='row'>
                    <div className='col-md-10 mt-2'>
                      <p className="fw-bold">Cheque Details</p>
                    </div>

                    <div className='col-md-6'>
                      <div>
                        <p className="sd-p">Cheque Number</p>
                        <p className="alg-l">{details.cheque_details.cheque_number}</p>
                      </div>
                    </div>
                    <div className='col-md-6'>

                      <div>
                        <p className="sd-p">Bank Name</p>
                        <p className="alg-l">{details.cheque_details.bank_name}</p>
                      </div>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-6'>
                      <div>
                        <p className="sd-p">IFSC</p>
                        <p className="alg-l">{details.cheque_details.ifsc_code}</p>
                      </div>
                    </div>
                    <div className='col-md-6'>

                      <div>
                        <p className="sd-p">Cheque Date</p>
                        <p className="alg-l">{details.cheque_details.cheque_date}</p>
                      </div>
                    </div>
                  </div>



                </>
              )}

              {details.dd_details && (
                <>


                  <div className='row'>
                    <div className='col-md-10 mt-2'>
                      <p className="fw-bold">Demand Draft Details</p>
                    </div>
                    <div className='col-md-6'>

                      <div>
                        <p className="sd-p">Issuing Bank Name</p>
                        <p className="alg-l">{details.dd_details.issuing_bank}</p>
                      </div>
                    </div>
                    <div className='col-md-6'>

                      <div>
                        <p className="sd-p">Issuing Branch Name</p>
                        <p className="alg-l">{details.dd_details.issuing_branch}</p>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-6'>

                      <div>
                        <p className="sd-p">Issuing Date</p>
                        <p className="alg-l">{details.dd_details.date_of_issuing}</p>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div>
                        <p className="sd-p">Payable At</p>
                        <p className="alg-l">{details.dd_details.payable_at}</p>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div>
                        <p className="sd-p">Payee name</p>
                        <p className="alg-l">{details.dd_details.payee_name}</p>
                      </div>
                    </div>

                    <div>
                      <p className="sd-p">Status</p>
                      <p className="alg-l">{details.payment_status}</p>
                    </div>
                  </div>



                </>
              )}

              {details.neft_rtgs_details && (
                <>
                  <div className='row'>
                    <div className='col-md-10 mt-2'>
                      <p className="fw-bold">
                        {details.payment_method} Details
                      </p>
                    </div>
                    <div className='col-md-6'>

                      <div>
                        <p className="sd-p">UTR Number</p>
                        <p className="alg-l">{details.neft_rtgs_details.utr_number}</p>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div>
                        <p className="sd-p">Bank Name</p>
                        <p className="alg-l">{details.neft_rtgs_details.bank_name}</p>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'><div>
                    <p className="sd-p">Transaction Date</p>
                    <p className="alg-l">
                      {details.neft_rtgs_details.transaction_date}
                    </p>
                  </div>

                    <div>
                      <p className="sd-p">Status</p>
                      <p className="alg-l">{details.payment_status}</p>
                    </div></div>

                </>
              )}
            </div>
          )}

        </div>
      ))}


    </>
  );
};
